import { GENETIC_INFO_TYPE_MAP } from '@constants/option-types/genetic-info';

import type { ObservationModelInput } from 'generated/types';

import { FhirResource, type BaseFhirFormValues } from './fhir-resource';
import type { ObservationValues } from './observation';
import { ObservationRecord } from './observation';

export type GeneticInfoValues = Pick<
  ObservationValues,
  'code' | 'selfReported' | 'testDate'
> & {
  // valueString
  title: string;
  associatedResources?: string[];
};

export type FormValues = BaseFhirFormValues & GeneticInfoValues;

export class GeneticInformationObservationRecord extends ObservationRecord {
  public override get value(): string | null {
    return this.model.valueString ?? null;
  }

  public set value(value: string | null | undefined) {
    this.model = {
      ...this.model,
      valueString: value ?? null,
    };
  }

  // Carrier status or Health risk
  public override get code(): string {
    const coding = this.model.code.coding?.find(({ system }) =>
      system?.startsWith('https://vitall.com')
    );
    return coding?.code ?? 'Unknown';
  }

  public set code(value: string | null | undefined) {
    this.model = {
      ...this.model,
      code: value
        ? {
            coding: [
              {
                code: value,
                display: GENETIC_INFO_TYPE_MAP[value],
                system: GeneticInformationObservationRecord.VITALL_SYSTEM,
              },
            ],
            text: GENETIC_INFO_TYPE_MAP[value],
          }
        : {},
    };
  }

  public override getModelInput(
    values?: GeneticInfoValues
  ): ObservationModelInput {
    if (values) {
      // eslint-disable-next-line guard-for-in
      for (const key in values) {
        try {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          this[key] = values[key];
        } catch {
          // eslint-disable-next-line no-continue
          continue;
        }
      }
      this.value = values.title;
    }
    const cleaned = FhirResource.getCleanInput(this.model);
    return cleaned;
  }
}
